import { PDFDocument } from 'pdf-lib';

import type { BatesRange, StampingConfig } from './models';
import { bakePages } from './page-baker';

export interface PDFInput {
  fileName: string;
  bytes: Uint8Array;
}

export interface PDFOutput {
  fileName: string;
  bytes: Uint8Array;
  range: BatesRange;
}

export async function stampBatch(
  files: PDFInput[],
  config: StampingConfig,
  startNumber: number,
): Promise<{ outputs: PDFOutput[]; log: BatesRange[] }> {
  if (files.length === 0) {
    return { outputs: [], log: [] };
  }

  const outputs: PDFOutput[] = [];
  const log: BatesRange[] = [];
  let nextNumber = startNumber;

  for (const file of files) {
    const pdf = await PDFDocument.load(file.bytes);
    const pageCount = pdf.getPageCount();

    if (pageCount < 1) {
      throw new Error(`Cannot stamp PDF with zero pages: ${file.fileName}`);
    }

    const range: BatesRange = {
      startNumber: nextNumber,
      endNumber: nextNumber + pageCount - 1,
      pageCount,
      fileName: file.fileName,
    };

    await bakePages(pdf, config, range);
    const stampedBytes = await pdf.save();

    outputs.push({
      fileName: file.fileName,
      bytes: stampedBytes,
      range,
    });
    log.push(range);

    nextNumber = range.endNumber + 1;
  }

  return { outputs, log };
}
